/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_New_Version_AvailableInputs */



/**
* | output |
* | --- |
* | "A new version of OpenRift is available." |
*
* @param {Common_New_Version_AvailableInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const common_new_version_available = /** @type {((inputs?: Common_New_Version_AvailableInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_New_Version_AvailableInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Eine neue Version von OpenRift ist verfügbar.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Une nouvelle version d'OpenRift est disponible.")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("OpenRift 有新版本可用。")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("OpenRift 有新版本可用。")
	if (locale === "ko") return /** @type {LocalizedString} */ ("OpenRift의 새 버전이 나왔습니다.")
	return /** @type {LocalizedString} */ ("A new version of OpenRift is available.")
});